import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { MysqlService } from 'app/services/mysql.service';
import { ActivatedRoute } from '@angular/router';
import { doc, Firestore, onSnapshot, setDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-videochat-ext',
  templateUrl: './videochat-ext.component.html',
  styleUrls: ['./videochat-ext.component.scss'],
  standalone: false
})


export class VideochatExtComponent implements OnInit, OnDestroy {

  sessionId: string;
  token: string;
  cmd: string;

  privacy: string = 'Modello Privacy in caricamento ...'


  @HostListener('window:unload', ['$event'])
  async handleClose($event) {
    await this.setOnlineStatus(false).then(res => console.log(res)).catch(err => console.log(err));
    //$event.returnValue = true;

    return true;
  }

  id: string;
  item;
  agent
  hideThumb: boolean;

  constructor(private route: ActivatedRoute,
    private firestore: Firestore,
    private db: MysqlService,
  ) {
    console.log('constructor')


    this.agent = window.navigator.userAgent

    //this.hideThumb = db.getIcon() == 'gg'

  }

  ngOnInit() {



    this.db.impostazioni.get('direct_privacy').then(res => {
      this.privacy = res[0].valore
      console.log('direct_privacy', this.privacy)

      window.document.getElementById('privacy').innerHTML = this.privacy

    })

    //alert('init')

    this.route.params.subscribe(res => {
      console.log('id:' + res.id)
      this.id = res.id;

      //alert('id: ' + this.id)

      this.loadData()
    })




  }

  loadData() {

    console.log('loaddata')


    const unsub = onSnapshot(doc(this.firestore, "requests", this.id), (docRef) => {

      const res = docRef.data()

      this.item = res;

      //alert('record found')
      console.log('record found', res)

      if (this.item.closed && this.item.okPrivacy) {
        alert('Teleperizia conclusa, la ringraziamo per la collaborazione!')
        return;
      }
      if (this.item.closed && this.item.okPrivacy === false) {
        alert('Teleperizia non possibile!')
        return;
      }

      //alert('not closed')
      console.log('not closed')

      if (this.item.cmd && this.item.cmd != '') {
        //alert('cmd ' + this.item.cmd)
        console.log('cmd ' + this.item.cmd)
        console.log('cmd received - ext: ', this.item.cmd);
        this.cmd = this.item.cmd;



        setTimeout(() => {
          this.cmd = '';
          this.update({ cmd: '' })
        }, 100)
      }


      //alert('sessionId ' + this.item.sessionId)

      if (!this.item.sessionId) {

        this.db.opentok.create_session().then(res => {
          console.log(res)
          this.item.sessionId = res;
          this.sessionId = this.item.sessionId




          // alert('created sessionId ' + this.item.sessionId)

          this.setOnlineStatus(true, res);

          this.generateToken()

        })
      } else {
        this.sessionId = this.item.sessionId
        this.generateToken()
        this.setOnlineStatus(true, this.sessionId);
      }

      // set agent //
      if (!this.item.agent) this.update({ agent: this.agent })

      if (this.item.okPrivacy) this.getGeo()

    })

  }

  update(data) {
    const docRef = doc(this.firestore, 'requests', this.id);
    return setDoc(docRef, data, { merge: true });
  }

  generateToken() {
    if (!this.token) {
      this.db.opentok.generate_token(this.sessionId).then(res => {
        console.log(res)
        this.token = res;
      })
    }
  }

  async setOnlineStatus(online: boolean, sessionId = null) {
    console.log('setting online:' + online)

    if (sessionId == null)
      await this.update({ online: online })
    else
      await this.update({ online: online, sessionId: sessionId })

    console.log('online:' + online)
  }

  ngOnDestroy() {
    console.log('ngOnDestroy')
    alert('ngOnDestroy')

    this.setOnlineStatus(false);
    alert('destroy')
    console.log('destroy')
  }


  async setOkPrivacy(b) {

    await this.update({ okPrivacy: b, okPrivacyDate: new Date(), closed: !b })

    if (b) this.getGeo()

  }

  getGeo() {
    if (!this.item.geo && this.item.okPrivacyGeo == undefined) {

      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(res => {




          //  alert('geo ok ')

          console.log(res.coords)

          const geo = {
            accuracy: res.coords.accuracy,
            latitude: res.coords.latitude,
            longitude: res.coords.longitude,
          }

          this.update({ geo: geo, okPrivacyGeo: true, okPrivacyGeoDate: new Date() })


        },
          err => {
            console.error(err)
            this.update({ geoErr: err.message, okPrivacyGeo: false, okPrivacyGeoDate: new Date() })
          }
        );
      };


    }

  }

  okPrivacyCam(b) {

    console.log('okPrivacyCam ' + b)
    this.update({ okPrivacyCam: b, okPrivacyCamDate: new Date(), closed: !b })

  }

  setStream(e) {

    console.log('setStream ', e)
    this.update({ stream: e })

  }
}
